(ns nosco.welcome.network
  (:require
   [nosco.ui.forms :as forms]
   [nosco.util :as util]))

;; this namespace doesn't use cljs-ajax, mainly for two reasons:
;; * keeping the bundle size down (cljs-ajax is brining in unneeded dependencies)
;; * exploring whether cljs-ajax is even needed. XHR is a bit verbose but since
;;   we don't support IE11 anymore, we can try fetch instead

(defn try-json [response]
  (try
    (when (util/non-blank response)
      (js->clj
       (js/JSON.parse response)))
    (catch :default e
      (js/console.error "JSON PARSE ERROR" e)
      ::error)))

(defn POST
  "Post to /welcome for signups"
  [url params callback errback]
  (let [load-listener (fn [r]
                        (let [req (.-target r)
                              status (.-status req)
                              response (.-response req)
                              json (try-json response)]
                          (js/console.log "REQ" req "STATUS" status "RESPONSE" response)
                          (cond
                            (<= 200 status 299)
                            (callback json)

                            :else
                            (errback {:status status
                                      :status-text (.-statusText req)
                                      :response (if (= ::error json)
                                                  {"message" response}
                                                  json)}))))
        error-listener (fn [r] (js/console.log "ERROR" r))]
    (doto (js/XMLHttpRequest.)
      (.addEventListener "load" load-listener)
      (.addEventListener "error" error-listener)
      (.open "POST" url)
      (.setRequestHeader "Content-Type" "application/json;charset=UTF-8")
      (.send (-> params clj->js  js/JSON.stringify)))))

(defn- login-response-params->args [^js url-search-params]
  {:error-code (.get url-search-params "error")
   :redir-ref (or (.get url-search-params "redirect-to")
                  (.get url-search-params "ref"))})

(defn parse-login-response-url
  "Convert a nosco-app /login response into a map with parameters pathname/args."
  [url-string]
  (let [url (js/URL. url-string)
        pathname (.-pathname url)
        params (js/URLSearchParams. (.-search url))]
    {:pathname pathname
     :args (login-response-params->args params)}))

(defn nosco-app-POST
  "Post to nosco-app /login. An error response redirects you back to /login with some error parameters.
   A successful response will redirect you to the target URL."
  [url params callback errback]
  ;; To login with email/password, POST a form to `/authorize` with email, password as form values (URL encoded)
  ;; Recaptcha or CSRF is not used for logging in
  ;; if an error occurs, you get redirected to the same page with `error=<x>` in the query string
  ;; otherwise you're redirected with a cookie

  ;; the errors are either 1/passwordless/deleted/blocked/inactive/2/3/access_denied
  ;; see login.html for the actual error strings
  (let [load-listener (fn [r]
                        (let [req (.-target r)
                              responseURL (.-responseURL req)
                              {:keys [pathname args]} (parse-login-response-url responseURL)]
                          (if (= pathname "/login")
                            (errback args)
                            (callback responseURL))))
        error-listener (fn [r]
                         (js/console.log "ERROR" r)
                         (errback {:error-code "unknown"}))]
    (doto (js/XMLHttpRequest.)
      (.addEventListener "load" load-listener)
      (.addEventListener "error" error-listener)
      (.open "POST" url)
      (.setRequestHeader "Content-Type" "application/x-www-form-urlencoded;charset=UTF-8")
      (.send (forms/map->urlencode params)))))
